import { useParams } from 'react-router-dom';

const Confirmation = () => {
  const { transactionId } = useParams();

  return <div>Confirmation page placeholder (transaction id {transactionId})</div>;
};

export { Confirmation };
